export const BASE_PAGE_TITLE = 'Deity Data Integrator';

export const DEFAULT_PAGINATION_SIZE = 25;
